import { PostPayload } from "@/app/api/types";
import { Entity, IField } from "@/app/fields/types";
import { DefaultValues } from "@saas-ui/react";

export const buildDefaultValues = <T extends Entity>(
  fields: IField<T>[]
): DefaultValues<PostPayload<T>> => {
  return fields.reduce(
    (prev, field) => ({
      ...prev,
      [String(field.field)]: getFieldDefault(field),
    }),
    {}
  ) as DefaultValues<PostPayload<T>>;
};

const getFieldDefault = <T extends Entity>(field: IField<T>): any => {
  if (field.type === "select" && field.is_multi) {
    return field.default_form_value || [];
  }
  return field.default_form_value;
};
